import { Component, OnInit } from '@angular/core';
import { WizardService } from '../wizard/wizard.service';
import { ReferralModel } from '../model/referral-model';
import { WizardStep } from '../wizard-step';
import { WizardNavigationService } from '../wizard/wizard-navigation.service';
import { AppSettings } from 'pac-api';

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.css']
})
export class ReferralComponent implements OnInit, WizardStep {

  public Name: string = 'ReferralComponent';

  public Referral: ReferralModel;

  public _ready = false;

  constructor(
    private wizard: WizardService,
    private navigation: WizardNavigationService,
    public Settings: AppSettings,
  ) {
  }

  public ngOnInit() {
    if (this.wizard.HasReferral) {
      this.wizard.GetReferral(this.wizard.Referral).subscribe(result => {
        this.Referral = result;

        this.wizard.Individual.cst_src_key = 'd05f2958-5327-4ceb-9c18-2d3a88a556bf';
        this.wizard.Individual.cst_src_option_select_ext = 'Another ABMP/ASCP/AHP/ANP member';
        this.wizard.Individual.cst_src_referral_member_first_name_ext = this.Referral.ind_first_name;
        this.wizard.Individual.cst_src_referral_member_last_name_ext = this.Referral.ind_last_name;
        this.wizard.Individual.cst_src_referral_cst_recno_ext = this.Referral.cst_recno;

        this.wizard.UpdateAccount().subscribe(result => this._ready = true);
      });

    } else {
      this._ready = true;
      this.navigation.next(this);
    }
  }

  public ready(): boolean {
    return this._ready;
  }

  public Submit(): void {
    if (this._ready) {
      this.navigation.next(this);
    }
  }
}
